import { businessData, businessData as businessDataAtom } from 'atoms';
import PageStructure from 'common/PageStructure';
import TabsStructure from 'pages/Business/Partials/TabsStructure';
import { useRecoilState } from 'recoil';
import { useTheme, useMediaQuery } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import Box from '@mui/material/Box';

import React, { useState, useEffect } from 'react';

const Business = () => {
    const theme = useTheme();
    const shouldScroll = useMediaQuery('(max-width: 975px)');
    const isTabletOrBelow = useMediaQuery('(max-width: 960px)');
    const isMobile = useMediaQuery('(max-width: 640px)');
    const [business, setBusiness] = useRecoilState(businessData);
    const [value, setValue] = useState(0);
    
    const isBuisnessAdded = business?.email?.length > 0 && business?.id > 0;
    const tabClass = 'business-tab-label';
    const tabClassActive = 'business-tab-label active';

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Scroll to top when component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Reset to Business tab if no business exists
    useEffect(() => {
        if (!isBuisnessAdded && value !== 0) {
            setValue(0);
        }
    }, [isBuisnessAdded, value]);

    // Define tabs based on business existence
    const tabs = [
        { label: "Business" }
    ];

    if (isBuisnessAdded) {
        tabs.push(
            { label: "Services" },
            { label: "Availability" },
            { label: "Providers" },
            { label: "Office Staff" },
            { label: "Out of Office" }
        );
    }

    const tabsElement = isBuisnessAdded ? (
        <Box 
            data-tabs="true"
            sx={{ 
                borderBottom: 1, 
                borderColor: 'divider', 
                backgroundColor: 'white !important',
                width: '100%',
                margin: 0,
                marginLeft: 0,
                marginRight: 0,
                paddingLeft: isMobile ? '20px' : (isTabletOrBelow ? '32px' : '60px'),
                paddingRight: shouldScroll ? '16px' : (isMobile ? '20px' : (isTabletOrBelow ? '32px' : '60px')),
                boxSizing: 'border-box',
            }}
        >
            <Tabs 
                value={value} 
                indicatorColor={'false'} 
                variant={shouldScroll ? 'scrollable' : 'standard'}
                scrollButtons={shouldScroll ? 'auto' : false}
                allowScrollButtonsMobile
                sx={{ 
                    backgroundColor: 'white !important',
                    marginLeft: 0,
                    marginRight: 0,
                    width: '100%',
                    '& .MuiTabs-scrollButtons': {
                        width: '48px !important',
                        flexShrink: 0,
                        minWidth: '48px',
                        marginLeft: shouldScroll ? '12px' : 0,
                    },
                    '& .MuiTabs-scrollButtons:first-of-type': {
                        marginLeft: shouldScroll ? '12px' : 0,
                        marginRight: shouldScroll ? 0 : undefined,
                    },
                    '& .MuiTabs-scrollButtons:last-of-type': {
                        marginLeft: shouldScroll ? 0 : undefined,
                        marginRight: shouldScroll ? '16px' : 0,
                    },
                    '& .MuiTabs-scrollButtons .MuiSvgIcon-root': {
                        fontSize: '24px !important',
                        width: '24px',
                        height: '24px',
                    },
                }} 
                onChange={handleChange}
            >
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        label={tab.label}
                        className={value === index ? tabClassActive : tabClass}
                        sx={{
                            textTransform: 'none',
                            minWidth: shouldScroll ? 'auto' : undefined,
                            padding: shouldScroll ? { xs: '12px 16px', sm: '12px 24px' } : undefined,
                        }}
                    />
                ))}
            </Tabs>
        </Box>
    ) : null;

    return (
        <PageStructure 
            heading={business?.name || 'Your Business'} 
            hideHeaderBorder={true}
            tabs={tabsElement}
        >
            <TabsStructure value={value} setValue={setValue}></TabsStructure>
        </PageStructure>
    );
};

export default Business;
